export default "__VITE_ASSET__KKKw2qK1__"